/**
 * Converts the string or number input value to Boolean
 * @param value - The value to be converted, it can be a string or number
 * @returns - Returns the converted Boolean value
 * Samples - toBoolean("true") => true, toBoolean("1") => false, toBoolean(1) => true,
 * Samples - toBoolean("false") => false, toBoolean(0) => false, toBoolean("is_true") => true
 */
export const toBoolean = (value: string | number): boolean => {
  if (typeof value === 'string') return value.toLowerCase().indexOf('true') > -1;
  else return Boolean(value);
};
